import dotcomShip from '@/schemaTypes/fragments/dotcom.ship'
import {defineField, defineType} from 'sanity'

export default defineType({
  name: 'shipCta',
  type: 'object',
  title: 'Ship CTA',
  fields: [
    {
      name: 'label',
      type: 'string',
    },
    {
      name: 'buttonType',
      type: 'buttonType',
    },
    defineField({...dotcomShip}),
  ],
  preview: {
    select: {
      title: 'label',
      subtitle: 'ship.name',
    },
    prepare({title, subtitle}) {
      return {
        title: title,
        subtitle: subtitle,
      }
    },
  },
})
